import * as React from 'react'
import { Popover as PopoverPrimitive } from 'radix-ui'

import { cn } from '@/lib/utils'

/**
 * `modal` mặc định bật, khác mặc định `false` của Radix.
 *
 * Nội dung popover được portal ra `document.body`. Khi popover mở từ bên trong
 * một Dialog, khoá cuộn của Dialog (`RemoveScroll` với `shards: [DialogContent]`)
 * chỉ cho cuộn trong dialog, nên mọi `wheel`/`touchmove` trên popover bị
 * `preventDefault()` — dropdown có thanh cuộn nhưng lăn chuột không nhúc nhích.
 * Nhánh `modal` của Radix dựng `RemoveScroll` riêng cho popover; khoá mới nhất
 * thắng, nên vùng cuộn hợp lệ trở lại chính là popover. Đây cũng là cách
 * `Select` và `DropdownMenu` của Radix tự xử lý.
 *
 * Đánh đổi: trang nền bị khoá cuộn và pointer ngoài bị chặn khi popover mở —
 * giống hệt `Select`. Chỗ nào thực sự cần tương tác với nền thì truyền
 * `modal={false}` một cách có chủ đích.
 */
function Popover({
    modal = true,
    ...props
}: React.ComponentProps<typeof PopoverPrimitive.Root>) {
    return (
        <PopoverPrimitive.Root data-slot="popover" modal={modal} {...props} />
    )
}

function PopoverTrigger({
    ...props
}: React.ComponentProps<typeof PopoverPrimitive.Trigger>) {
    return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />
}

function PopoverContent({
    className,
    align = 'start',
    sideOffset = 4,
    ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) {
    return (
        <PopoverPrimitive.Portal>
            <PopoverPrimitive.Content
                data-slot="popover-content"
                align={align}
                sideOffset={sideOffset}
                className={cn(
                    'bg-popover text-popover-foreground z-50 w-72 rounded-md border shadow-md outline-none ring-1 ring-black/5',
                    className,
                )}
                {...props}
            />
        </PopoverPrimitive.Portal>
    )
}

export { Popover, PopoverTrigger, PopoverContent }
